export const purchaseHistoryTableConstants = {
    GET_PURCHASE_START_MONTH: 'GET_PURCHASE_START_MONTH',
    GET_PURCHASE_END_MONTH: 'GET_PURCHASE_END_MONTH',
    GET_PURCHASE_HIST_BY_DATE: 'GET_PURCHASE_HIST_BY_DATE',

    GET_PREV_PURCHASE_HISTORY: 'GET_PREV_PURCHASE_HISTORY',
    GET_NEXT_PURCHASE_HISTORY: 'GET_NEXT_PURCHASE_HISTORY'
}